import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
import {
  mdiCalendarCheck,
  mdiEmailOutline,
  mdiFacebook,
  mdiInstagram,
  mdiLinkVariant,
  mdiTrophyOutline,
  mdiTwitter,
  mdiYoutube,
} from '@mdi/js'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { useImage } from '@/shared/composables/image'
import { userApi, UserDB } from '@/enitites/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePlayerCard',
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
  user: UserDB
};



const { saveImage, getFlag, getImageById } = useImage()

const loading = ref(false)
const fileImg = ref<FileList | null>(null)
const srcImg = ref('')
const error = ref<string | null>(null)

const getUserDB = computed(() => store.getters.getUserDB)

const age = computed(() => {
  if (!props.user.id || !props.user.birthday) return 0
  const birthday = new Date(props.user.birthday)
  const ageMs = Date.now() - birthday.getTime()
  const ageDate = new Date(ageMs)
  return Math.abs(ageDate.getUTCFullYear() - 1970)
})

const saveImgCard = async () => {
  error.value = null
  if (!fileImg.value) return

  loading.value = true
  getUserDB.value.card = await saveImage(fileImg.value[0])
  await userApi.updateUser(getUserDB.value)
  await store.dispatch('showAlertToast', 'changesSaved')
  loading.value = false
}

const handlerFileChange = (evt: Event) => {
  const target = evt.target as HTMLInputElement
  fileImg.value = target.files || null

  if (!fileImg.value || !fileImg.value.length) return
  loading.value = true
  const reader = new FileReader()
  reader.onload = (event) => {
    srcImg.value = event.target?.result as string
    saveImgCard()
  }
  reader.readAsDataURL(fileImg.value[0])
}

onMounted(() => {
  srcImg.value = getImageById(props.user.card, 800, 800, 'card')
})

return { __sfc: true,props, saveImage, getFlag, getImageById, loading, fileImg, srcImg, error, getUserDB, age, saveImgCard, handlerFileChange, mdiCalendarCheck, mdiEmailOutline, mdiFacebook, mdiInstagram, mdiLinkVariant, mdiTrophyOutline, mdiTwitter, mdiYoutube }
}

})